module.exports = __webpack_public_path__ + "static/img/1设计师2.aa4156f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/设计市场/1设计师2.png
// module id = /pjh
// module chunks = 1